// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-beta .message-bubble-button[data-v-5632406e]{word-wrap:break-word;font-size:12px!important;border-radius:8px;line-height:16px}.ui-beta .message-bubble-button.blue-button[data-v-5632406e]{border:1px solid #4e6cce;color:#4e6cce;background:#fff}.ui-beta .message-bubble-button.blue-button[data-v-5632406e]:hover{color:#fff;background:#4e6cce}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
